import { Component } from '@angular/core';
import { IAfterGuiAttachedParams, IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
    selector: 'app-transmission-status-filter',
    imports: [CommonModule, FormsModule],
    template: `
    <div class="transmission-status-filter">
      <select [(ngModel)]="selectedValue" (change)="onSelectionChanged()" class="form-control">
        <option value="">All</option>
        <option value="Waiting">Waiting</option>
        <option value="Success">Success</option>
        <option value="Failed">Failed</option>
      </select>
    </div>
  `,
    styles: [`
    .transmission-status-filter {
      padding: 4px;
    }
    .form-control {
      width: 100%;
      padding: 4px 8px;
      border: 1px solid #d3d3d3;
      border-radius: 4px;
    }
  `]
})
export class TransmissionStatusFilterComponent implements IFilterAngularComp {

  statusCodeMap: Record<string, number> = {
    'Waiting': 0,
    'Success': 1,
    'Failed': 2,
  };

  selectedValue: string = '';
  params!: IFilterParams;

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  isFilterActive(): boolean {
    return this.selectedValue !== '';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    if (!this.isFilterActive()) {
      return true;
    }

    const cellValue = params.data?.primeTransmissionStatus?.statusCode;

    const expectedStatusCode = this.statusCodeMap[this.selectedValue];
    return cellValue === expectedStatusCode;
  }

  getModel(): any {
    if (!this.isFilterActive()) {
      return null;
    }

    // Return the numeric status code for the backend filter
    return {
      filterType: 'text',
      type: 'equals',
      filter: this.statusCodeMap[this.selectedValue]
    };
  }

  setModel(model: any): void {
    if (!model || model.filter === undefined) {
      this.selectedValue = '';
      return;
    }

    // Find the string key that maps to the numeric filter value
    const filterValue = model.filter;
    const statusEntry = Object.entries(this.statusCodeMap).find(([key, value]) => value === filterValue);

    this.selectedValue = statusEntry ? statusEntry[0] : '';
  }

  onSelectionChanged(): void {
    this.params.filterChangedCallback();
  }

  afterGuiAttached(params?: IAfterGuiAttachedParams): void {
    // Focus the select element if needed
  }

  getModelAsString(): string {
    return this.selectedValue || '';
  }
}